import { computed } from 'vue';
import { Collection } from '@/store/common/collections';
import { useVendorsStore } from '@/store/vendors-store';
import { Vendor } from '@/model/vendor';
import { useEmployeesStore } from '@/store/employees-store';
import { useMachinesStore } from '@/store/machines-store';
import { useWorkplacesStore } from '@/store/workplaces-store';
import { useServicesStore } from '@/store/services-store';
import { useClosedDatesStore } from '@/store/closed-dates-store';
import { useRegionsStore } from '@/store/regions-store';

// Replaces: ResourceConfigMixin
export function useResourceConfig() {
  const vendorsStore = useVendorsStore();
  const employeesStore = useEmployeesStore();
  const machinesStore = useMachinesStore();
  const workplacesStore = useWorkplacesStore();
  const servicesStore = useServicesStore();
  const closedDatesStore = useClosedDatesStore();
  const regionsStore = useRegionsStore();

  const vendor = computed((): Vendor => {
    return vendorsStore.currentEntity;
  });

  function hasConfigurationErrors(
    collectionName: Collection,
    entityId?: number,
  ): boolean {
    switch (collectionName) {
      case Collection.EMPLOYEES:
        return employeesStore.hasConfigurationErrors(entityId);
      case Collection.SERVICES:
        return servicesStore.hasConfigurationErrors(entityId);
      case Collection.WORKPLACES:
        return workplacesStore.hasConfigurationErrors(entityId);
      case Collection.MACHINES:
        return machinesStore.hasConfigurationErrors(entityId);
      case Collection.CLOSED_DATES:
        return closedDatesStore.hasConfigurationErrors(entityId);
      case Collection.REGIONS:
        return regionsStore.hasConfigurationErrors(entityId);
      default:
        return false;
    }
  }

  function getConfigurationErrors(
    collectionName: Collection,
    entityId: number,
  ): string {
    switch (collectionName) {
      case Collection.EMPLOYEES:
        return employeesStore.getConfigurationErrors(entityId);
      case Collection.SERVICES:
        return servicesStore.getConfigurationErrors(entityId);
      case Collection.WORKPLACES:
        return workplacesStore.getConfigurationErrors(entityId);
      case Collection.MACHINES:
        return machinesStore.getConfigurationErrors(entityId);
      case Collection.CLOSED_DATES:
        return closedDatesStore.getConfigurationErrors(entityId);
      case Collection.REGIONS:
        return regionsStore.getConfigurationErrors(entityId);
      default:
        return '';
    }
  }

  return {
    vendor,
    hasConfigurationErrors,
    getConfigurationErrors,
  };
}
